import { CalendarX } from "@phosphor-icons/react";
import { useTranslation } from "react-i18next";

/** The only reason booking is closed is a therapist with no active services. */
export function BookingClosedNotice() {
  const { t } = useTranslation();
  const titleKey = "therapistDetail.notStartedTitle";
  const descriptionKey = "therapistDetail.notStartedDesc";

  return (
    <div className="rounded-2xl border border-amber-200 bg-amber-50 p-5 text-center shadow-sm sm:p-6">
      <div className="mx-auto flex size-10 items-center justify-center rounded-xl bg-amber-100">
        <CalendarX className="size-5 text-amber-600" weight="duotone" />
      </div>
      <h3
        className="mt-3 text-sm font-semibold text-amber-900"
        style={{ fontFamily: "var(--font-heading)" }}
      >
        {t(titleKey)}
      </h3>
      <p className="mt-1 text-sm text-amber-700">{t(descriptionKey)}</p>
    </div>
  );
}
